import BaseService from './base.service'

export default class OrdenesCompraService extends BaseService {
    getAll(fnSuccess, fnError) {
        return this.getApi().get(`/ordenesCompra`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al obtener las órdenes de compra')));
    }

    getArticulosById(id, fnSuccess, fnError) {
        return this.getApi().get(`/ordenesCompra/articulos?id=${id}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al obtener los artículos de la orden de compra')));
    }
}
